/** localStorage key holding the selected dev persona. Shared with Playwright fixtures. */
export const DEV_PERSONA_STORAGE_KEY = "anthm.dev.persona";
